<template>
    <div>
        <!-- 面包屑导航 -->
        <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
        <!-- 面包屑导航 -->
        <div class="content c-top">
            <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
            <div>
                <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
                    <el-form-item label="标题名称" prop="name">
                        <el-input style="width: 232px" v-model="searchForm.name" placeholder="请输入标题名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item class="form-btn">
                        <el-button type="primary" @click="fetchData('search')">查询</el-button>
                        <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="content">
            <div class="title">
                <h3>列表数据</h3>
                <div>
                    <el-button type="primary" style="width:92px;height: 36px;" @click="deleteAll">批量删除</el-button>
                    <el-button type="primary" style="width:92px;height: 36px;" @click="add">新增</el-button>
                </div>
            </div>
            <div id="base-list">
                <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
                    layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                    :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection"
                    @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
                </lb-table>
            </div>
        </div>
        <el-dialog title="活动详情" :visible.sync="isAdd" width="487px" :append-to-body="true" :close-on-click-modal="false">
            <div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" size="small" class="ruleForm">
                    <el-form-item label="活动标题" prop="name">
                        <el-input v-model="ruleForm.name" placeholder="请输入活动标题"></el-input>
                    </el-form-item>
                    <el-form-item label="参与人数" prop="inNum">
                        <el-input v-model="ruleForm.inNum" οnkeyup="value=value.replace(/^[1-9]\d*$/,'')"
                            placeholder="请输入参与人数"></el-input>
                    </el-form-item>
                    <el-form-item label="排序" prop="sort">
                        <el-input v-model="ruleForm.sort" type="number" placeholder="请输入排序"></el-input>
                    </el-form-item>
                    <el-form-item label="跳转地址" prop="url">
                        <el-input v-model="ruleForm.url" placeholder="请输入跳转地址"></el-input>
                    </el-form-item>
                    <el-form-item label="主图" prop="image">
                        <template>
                            <upload-picture :imageUrl="ruleForm.image" @getUrl="getImage"></upload-picture>
                            <p style="font-size: 12px;color: rgb(153, 153, 153);">请上传图片为690px*300px</p>
                        </template>
                    </el-form-item>
                    <el-form-item label="内容" prop="detail">
                        <el-input v-model="ruleForm.detail" type="textarea" placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="是否启用" prop="status">
                        <el-switch v-model="ruleForm.status"></el-switch>
                    </el-form-item>
                </el-form>
            </div>
            <div style="display: flex; justify-content: end; margin-top: 24px">
                <div class="info-q" @click="isAdd = false">取消</div>
                <div class="info-s" @click="addSubmit">确定</div>
            </div>
        </el-dialog>
        <el-dialog title="温馨提示" :visible.sync="isDelete" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
            <template>
                <div class="info" style="text-align: left">
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    是否确认删除，删除后数据不可恢复！
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isDelete = false">取消</div>
                    <div class="info-s" @click="submitD()">确定</div>
                </div>
            </template>
        </el-dialog>

    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
import uploadPicture from '@/components/upload/mallPicture.vue'
export default {
    components: {
        breadcrumbTop,
        breadcrumbSearch,
        LbTable,
        uploadPicture
    },
    data() {
        var validatePhone = async (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号'));
            } else {
                if (!(/^1[3456789]\d{9}$/.test(value))) {
                    callback(new Error('请输入正确手机号'));
                } else {
                    await this.axios.get('/employee/checkPhone?phone=' + value).then(res => {
                        if (res.code == 0) {
                            console.log(res.data)
                            if (res.data == false) {
                                callback(new Error('该手机号已添加为员工，请重新输入'));
                            }
                        }
                    })
                }
                callback();
            }
        };

        var validateAgain = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入手机号'));
            } else {
                if (!(/^1[3456789]\d{9}$/.test(value))) {
                    callback(new Error('请输入正确手机号'));
                } else {
                    if (this.ruleForm.phone != value) {
                        callback(new Error('输入手机号不一致，请重新输入'));
                    }
                }
                callback();
            }
        };
        return {
            isDelete: false,
            id: '',
            radio: '1',
            ruleForm: {
                id: null,
                name: '',
                sort: '',
                url: '',
                inNum: '',
                image: '',
                detail: '',
                status: false
            },
            rules: {
                name: [
                    { required: true, message: '请输入活动标题', trigger: 'blur', },
                    // { min: 1, max: 11, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                sort: [
                    { required: true, message: '请输入排序', trigger: 'blur' }
                ],
                inNum: [
                    {
                        pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
                        required: true,
                        message: '请输入数量，且为正整数类型',
                        trigger: 'blur'
                    },
                    { required: true, message: '请输入参与人数', trigger: 'blur' },

                ],
                image: [
                    { required: true, message: '请上传图片', trigger: 'blur' }
                ],
                detail: [
                    { required: true, message: '请输入内容', trigger: 'blur' }
                ]
            },
            isEdit: false,
            isAdd: false,
            dataList: {
                list: [
                    { title: '基本配置', path: '', type: '0' },
                    { title: '发现列表', path: '/systemManagement/memberManagement', type: '1' }
                ]
            },
            searchList: {
                list: [
                    { title: '发现列表', path: '', type: '0' },
                    { title: '数据筛选', path: '', type: '1' }
                ]
            },
            list: [],
            searchForm: {
                name: '',
                pageNo: 1,
                pageSize: 10
            },
            value1: [],
            value2: [],
            stars: [

            ],
            columns: [
                { type: 'selection' },
                {
                    label: 'ID', minWidth: '80', prop: 'id'
                },
                {
                    label: '标题', prop: 'name'
                },
                {
                    label: '主图', prop: 'image', minWidth: '300',
                    render: (h, scope) => {
                        let img = scope.row.image ? scope.row.image : require('../../../assets/icon_touxiang_106@2x.png')
                        return (
                            <div style="display:flex;justify-content:center;">
                                <div>
                                    <el-image style="width:64px;height:64px;border-radius:50%;" src={img} preview-src-list={[img]} lazy></el-image>
                                </div>
                            </div>
                        )
                    }
                },
                {
                    label: '内容', prop: 'detail'
                },
                {
                    label: '是否启用', prop: 'status',
                    render: (h, scope) => {
                        let check = scope.row.status
                        return (
                            <div>
                                <el-switch vModel={scope.row.status} onChange={($event) => { this.changeSw(scope.row) }}></el-switch>
                            </div>
                        )
                    }
                },
                {
                    label: '更新日期', prop: 'updatedTime',
                },
                {
                    label: '排序', prop: 'sort'
                },
                {
                    label: '操作',
                    minWidth: '100',
                    fixed: 'right',
                    render: (h, scope) => {
                        return (
                            <div>
                                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.toEdit(scope.row) }}>编辑</span>
                                <span style='color:red;cursor:pointer;margin-left:10px;' onClick={() => { this.deleteFn(scope.row) }}>删除</span>
                            </div >
                        )
                    }
                }],
            page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            exporting: false,
            isName: '',
            cId: '',
            showFlag: '',
            userName: '',
            userId: '',
            phone: '',
            status: '',
            ids: [],
            selectList: []
        }
    },
    created() {
        this.getPageList()
    },
    // beforeRouteEnter(to, from, next) {
    //     if (from.name == 'addComment') {
    //         next(vm => {
    //             vm.getPageList();
    //         });
    //     } else {
    //         next(vm => {
    //             vm.getPageList();
    //         });
    //     }
    // },
    methods: {
        deleteAll() {
            if (this.selectList.length == 0) {
                this.$message.warning('请选择表格数据')
                return
            }
            this.ids = this.selectList.map(item => {
                return item.id
            })
            this.isDelete = true;
        },
        submitD() {
            this.axios.post('/discoverActivate/delete', { id: this.ids })
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.isDelete = false
                        this.$message.success('删除成功')
                        this.page.pageNo = 1;
                        this.getPageList()
                    }
                })
        },
        deleteFn(row) {
            this.isDelete = true;
            this.ids = [row.id];
        },
        changeSw(row) {
            console.log(row)
            let status = 1
            if (row.status == false) {
                status = 2
            } else {
                status = 1
            }
            let data = {
                id: row.id,
                status: status
            }
            this.axios.post('/discoverActivate/onOff', data).then(res => {
                if (res.code == 0) {
                    this.$message.success('操作成功')
                    this.getPageList()
                }
            })
        },
        getImage(e) {
            console.log(e)
            this.ruleForm.image = e;
        },
        addSubmit() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.ruleForm.id = this.id || null
                    this.ruleForm.status = this.ruleForm.status == true ? 1 : 2
                    this.axios.post('/discoverActivate/addEdit', this.ruleForm).then(res => {
                        if (res.code == 0) {
                            this.$message.success('添加成功')
                            this.isAdd = false
                            this.getPageList()
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        add() {
            this.isAdd = true
            let ruleForm = {
                // id: null,
                name: '',
                sort: '',
                url: '',
                inNum: '',
                image: '',
                detail: '',
                status: false
            }
            this.ruleForm = ruleForm;
            this.id = null
            // this.$nextTick(()=>{
            //     Object.keys(this.ruleForm).forEach(item=>{
            //     console.log(item,'==',this.ruleForm[item])
            //     this.ruleForm[item] = ''
            //     if(item == 'status'){
            //         this.ruleForm[item] = false
            //     }
            // })
            // })
            this.$nextTick(() => {
                this.$refs['ruleForm'].clearValidate()
            })

        },
        updateStatus() {
            let data = {
                id: this.id,
                status: Number(this.radio)
            }
            this.axios.post('/employee/edit', data).then(res => {
                if (res.code == 0) {
                    this.$message.success('更改成功')
                    this.isEdit = false
                    this.getPageList()
                }
            })
        },
        isShow(row) {
            this.isS = true
            this.isName = row.statusL
            this.cId = row.id
            console.log(row.showFlag)
            this.showFlag = !row.showFlag
        },
        fetchData(type) {
            this.page.pageNo = 1;
            if (type == 'reset') {
                this.$nextTick(() => {
                    this.$refs['ruleForm'].resetFields()
                })
                this.value1 = []
                this.value2 = []
                this.searchForm.name = ''
            }
            this.getPageList()
        },
        getPageList() {
            this.searchForm.pageNo = this.page.pageNo;
            this.searchForm.pageSize = this.page.pageSize;
            this.axios.post('/discoverActivate/pageList', this.searchForm)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        res.data.list.forEach(item => {
                            item.status = item.status == 1 ? true : false
                        })
                        this.list = res.data.list;
                        this.page.totalNum = res.data.totalNum;
                    }
                })
        },
        onMultipleSelection(e) {
            console.log(e)
            this.selectList = e;
        },
        handleSizeChange(e) {
            this.page.pageSize = e;
            this.page.pageNo = 1;
            this.getPageList()
        },
        handleCurrentChange(e) {
            this.page.pageNo = e;
            this.getPageList()
        },
        toEdit(row) {
            this.isAdd = true
            this.$nextTick(() => {
                this.$refs['ruleForm'].clearValidate()
            })
            console.log(row)
            row.status = row.status == 1 ? true : false
            this.ruleForm = row;
            // this.userName = row.userName || '--'
            // this.userId = row.userId || '--'
            // this.phone = row.phone || '--'
            // this.radio = String(row.status)
            this.id = row.id
        }
    }
}
</script>
  
<style scoped lang="scss">
.info-q {
    width: 124px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border: 1px solid #909099;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    margin-right: 18px;
    cursor: pointer;
}

.info-s {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #2d46ee;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}

.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

#base-list {
    margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
    display: inline-block;

    a {
        margin: 0 5px;
    }
}

.search-form {
    // margin-top: 20px;
    display: flex;
    flex-wrap: wrap;

    .el-form-item {
        /deep/ .el-form-item__label {
            width: 100px;
            text-align: right;
            vertical-align: middle;
            float: left;
            box-sizing: border-box;
        }

        /deep/ .el-form-item__content {
            display: block;
            margin-left: 100px;

            .el-cascader,
            .el-select {
                width: 100%;
            }
        }
    }

    .form-btn {
        /deep/ .el-form-item__content {
            line-height: 36px;
            margin-left: 50px;
        }
    }
}

/deep/ .el-table__row {
    .el-table__cell {
        padding: 12px 0;
    }
}

/deep/ .el-table {
    color: #303033;
}
</style>
  
  